// Function to calculate total offset from headers
function calculateHeaderOffset() {
    let totalOffset = 0;
    
    // Check for sticky offset header
    const stickyHeader = document.querySelector('.sticky-offset-header');
    if (stickyHeader) {
        totalOffset += stickyHeader.offsetHeight;
    }
    
    // Check for regular header
    const header = document.querySelector('header');
    if (header) {
        totalOffset += header.offsetHeight;
    }
    
    // Add a small buffer for spacing (optional)
    const buffer = 20;
    totalOffset += buffer;
    
    return totalOffset;
}

// Function to handle smooth scrolling with dynamic offset
function initSmoothScroll() {
    // Select all anchor links that have a hash
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    
    anchorLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            // Prevent default anchor behavior
            e.preventDefault();
            
            // Get the target element from the href
            const targetId = this.getAttribute('href');
            
            // Skip if it's just "#"
            if (targetId === '#') return;
            
            const targetElement = document.querySelector(targetId);
            
            // Check if target element exists
            if (!targetElement) {
                console.warn(`Target element ${targetId} not found`);
                return;
            }
            
            // Calculate current header offset
            const headerOffset = calculateHeaderOffset();
            
            // Calculate the target position with dynamic offset
            const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerOffset;
            
            // Perform the smooth scroll
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        });
    });
}

// Initialize smooth scrolling when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    initSmoothScroll();
});

// Optional: Recalculate offset on window resize in case header height changes
window.addEventListener('resize', () => {
    // You might want to debounce this in production
    calculateHeaderOffset();
});
